// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JvXH","title":"styles_title__3Hx_j"};